import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface DelegatableUser {
	id: string;
	name: string;
	email: string;
}

interface DelegationResponse {
	canDelegate: boolean;
	users: DelegatableUser[];
}

export function useDelegation() {
	const query = useQuery({
		queryKey: ["delegation"],
		queryFn: () => api.get<DelegationResponse>("/api/settings/delegation"),
		staleTime: 5 * 60 * 1000,
	});

	return {
		canDelegate: query.data?.canDelegate ?? false,
		users: query.data?.users ?? [],
		isLoading: query.isLoading,
	};
}
